module.exports = __webpack_public_path__ + "static/media/Logo2.489a4840.png";